import React, { Component, useState, useEffect } from 'react';
import Select from 'react-select';

import { getExistingDatasets } from '../../api';

const SelectDataset = props => {

    const [defaultValue, setDefaultValue] = useState(null);
    const [datasetList, setDatasetList] = useState([]);
    const [isOnlyYear, setIsOnlyYear] = useState(false);
    const [isDisabled, setIsDisabled] = useState(props.isDisabled);

    useEffect(() => {
        getLoadData(props.chart, props.indicator, props.esener, props.yearOnly, props.split);
    }, [])

    useEffect(() => {
        getLoadData(props.chart, props.indicator, props.esener, props.yearOnly, props.split);
    }, [props.chart, props.datasetSelected, props.isTrend])

    useEffect(() => {
        if (props.reset == true)
        {
            getLoadData(props.chart, props.indicator, props.esener, props.yearOnly, props.split);
        }
    }, [props.reset])

    useEffect(() => {
        if (defaultValue)
        {
            if (defaultValue.label.includes(','))
            {
                setIsOnlyYear(false);
            }
            else
            {
                setIsOnlyYear(true);
            }
        }
    }, [defaultValue])

    useEffect(() => {
        setIsDisabled(props.isDisabled);
    }, [props.isDisabled])

    const getLoadData = (chart, indicator, isEsener, yearOnly, split) => {
        let chartType = null;
        let selectedChart = chart;
        let selectedIndicator = indicator;
        if(selectedChart && selectedIndicator){
            if(props.chartType){
                chartType = props.chartType.find( (chart) => chart.type == props.datasetSelected );
                selectedChart = chartType.chart;
                selectedIndicator = chartType.chartIndicator;
            }
        }

        getExistingDatasets(selectedChart, selectedIndicator, isEsener, 
            props.isTrend ? props.datasetSelected : undefined, yearOnly, split)
        .then((res) => {
            if(res.resultset.length){
                let data = res.resultset.find(element=> (element.default) == true);
                const disabled = props.isDisabled || res.resultset.length == 1 ? true : false;
                if (data)
                {
                    if(props.defaultValue == false)
                    {
                        setDefaultValue({
                            label: 'Dataset',
                            value: null
                        });
                    }
                    else
                    {
                        setDefaultValue({
                            label: data.sourceYear,
                            value: data.id
                        });
                    }                    
                }
                else
                {
                    data = res.resultset[0]
                    setDefaultValue({
                        label: data.sourceYear,
                        value: data.id
                    });
                }

                handleDefaultDataset(data.id, data.sourceYear, selectedIndicator, disabled);

                setDatasetList(res.resultset);
                setIsDisabled(disabled);
            }

            if(res.resultset.length == 0){
                setDefaultValue({
                    label: 'Dataset',
                    value: null
                })
                setIsDisabled(true);
            }
	    });
    }

    const handleDefaultDataset = (dataset, label, selectedIndicator, isDisabled) => {
        if(props.handleDefaultDataset){
            props.handleDefaultDataset(dataset, selectedIndicator, label, isDisabled);
        }else{
            props.handleDatasetChange(dataset, selectedIndicator, label, isDisabled);
        }
    }

    const handleDatasetChange = (e, indicator, label) => {
        if(props.showButtons)
        {
            e.preventDefault();
            setDefaultValue({
                label: e.label,
                value: e.value
            })
        }
        else
        {
            setDefaultValue({
                label: e.label,
                value: e.value
            })
            props.handleDatasetChange(e.value, indicator, label, isDisabled);
        }        
    }

    const applyFilterChange = (e) => {
        e.preventDefault();
        props.handleDatasetChange(defaultValue.value, props.indicator, defaultValue.label, isDisabled);
    }

    const resetFilter = (e) => {
        e.preventDefault();
        props.handleDatasetChange(null, props.indicator, null, isDisabled);
    }

    let buttonDiv = '';

    if(props.showButtons){
        buttonDiv = (
            <div className='dataset-filter-buttons'>
                <button className='btn-default btn-main-color' onClick={ (e) => resetFilter(e) } >{ props.literals.L20628 }</button>
            </div>
        )
    }

    return(
        <div>
            <Select
                onChange={ (e) => handleDatasetChange(e, props.indicator, e.label) }
                value={ defaultValue }
                className={`select-component ${ isOnlyYear ? '' : 'only-year' } ${ isDisabled ? 'disabled' : '' }`}
                options={ datasetList.map(item=>({ label: item.sourceYear, value: item.id })) }
                isDisabled={ isDisabled }
            />
            {buttonDiv}
        </div>
    )
}

export default SelectDataset;